import DocumentTagChip from './DocumentTagChip';

export default DocumentTagChip;
